import request from '@/method/request';
import { Spin, Table, Row, DatePicker, message } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { compute, setKarte } from './compute';
import { columns, defaultData } from './data'
import _ from 'lodash';
import './index.scss';
const { MonthPicker } = DatePicker;
class index extends Component {
    state = {
        date: moment().subtract(1, 'month').format('YYYY-MM'),
        data: [],
        key: 0,
        loading: true
    }

    componentDidMount() {
        this.getData(this.state.date);
    }

    getData = async (date) => {
        let data = _.cloneDeep(defaultData);
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const res = await request(`/t7_1_3chart?year=${year}&month=${month}`);
            if (res.data.data && res.data.data.length) {
                data = res.data.data.sort((a, b) => a.sort - b.sort);
            }
            data = compute(res.data, data);

            this.setState({ loading: false, data }, () => {
                this.onSave();
                this.setChart(this.state.key);
            });
        } catch (error) {
            console.error(error, '数据加载错误！');
            this.setState({ loading: false });
        }
    }

    onSelectKey = key => {
        this.setState({ key });
        this.setChart(key)
    }

    setChart = async (key = 0) => {
        try {
            const { date } = this.state;
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const res = await request(`/t7_1_3chartLst?year=${year}&month=${month}`);
            const list = new Array(12).fill(1).map((x, i) => i + 1);
            let dataY = [{
                name: "酒店总收入",
                data: list.map(x => _.get(res, `data.total.${x}`))
            }, {
                name: "酒店总人力成本",
                data: list.map(x => _.get(res, `data.totalHr.${x}`))
            }, {
                name: "客房部门收入",
                data: list.map(x => _.get(res, `data.room.${x}`))
            }, {
                name: "客房部门人力成本",
                data: list.map(x => _.get(res, `data.roomHr.${x}`))
            }, {
                name: "客房部门帮工费用",
                data: list.map(x => _.get(res, `data.roomLab.${x}`))
            }, {
                name: "餐饮部门收入",
                data: list.map(x => _.get(res, `data.food.${x}`))
            }, {
                name: "餐饮部门人力成本",
                data: list.map(x => _.get(res, `data.foodHr.${x}`))
            }, {
                name: "餐饮部门帮工费用",
                data: list.map(x => _.get(res, `data.foodLab.${x}`))
            }, {
                name: "其他营业部门收入",
                data: list.map(x => _.get(res, `data.other.${x}`))
            }, {
                name: "其他营业部门人力成本",
                data: list.map(x => _.get(res, `data.otherHr.${x}`))
            }];
            if (key == 0) dataY = dataY.slice(0, 2);
            if (key == 1) dataY = dataY.slice(2, 5);
            if (key == 2) dataY = dataY.slice(5, 8);
            if (key == 3) dataY = dataY.slice(8);

            setKarte({
                dataY
            })
        } catch (error) {
            console.log(error);
        }
    }
    getValue = (v = 0, type) => {
        if (type == 'percent') return `${(v * 100).toFixed(2).toString()}%`;
        return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    onSave = () => {
        let date = this.state.date;
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");

        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();

        dataFrom.append('data', JSON.stringify(data));

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/t7_1_3chartSave', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    render() {
        const { loading, data } = this.state;
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_1_3">
                    <Row className="title">
                        <Row>7.1.3 数据可视化</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        {/* <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: 800 }}
                            rowKey={(record, index) => index}
                        /> */}
                        <div className="chart-list">
                            <div className="item" onClick={() => this.onSelectKey(0)}>
                                <div className="child" style={{ backgroundColor: _.get(data, '0.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">酒店总收入</div>
                                    <div className="value" >较去年同期差值 {this.getValue(_.get(data, '0.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '0.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '1.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">酒店总人力成本</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '1.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '1.rat', 0), 'percent')}</div>
                                </div>
                            </div>
                            <div className="item" onClick={() => this.onSelectKey(1)}>
                                <div className="child" style={{ backgroundColor: _.get(data, '2.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">客房部门收入</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '2.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '2.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '3.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">客房部门人力成本</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '3.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '3.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '4.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">客房部门帮工费用</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '4.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '4.rat', 0), 'percent')}</div>
                                </div>
                            </div>
                            <div className="item" onClick={() => this.onSelectKey(2)}>
                                <div className="child" style={{ backgroundColor: _.get(data, '5.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">餐饮部门收入</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '5.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '5.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '6.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">餐饮部门人力成本</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '6.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '6.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '7.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">餐饮部门帮工费用</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '7.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '7.rat', 0), 'percent')}</div>
                                </div>
                            </div>
                            <div className="item" onClick={() => this.onSelectKey(3)}>
                                <div className="child" style={{ backgroundColor: _.get(data, '8.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">其他营业部门收入</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '8.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '8.rat', 0), 'percent')}</div>
                                </div>
                                <div className="child" style={{ backgroundColor: _.get(data, '9.diff', 0) < 0 ? "#50B07A" : "#E37646" }}>
                                    <div className="name">其他营业部门人力成本</div>
                                    <div className="value">较去年同期差值 {this.getValue(_.get(data, '9.diff', 0))}</div>
                                    <div className="value">较去年同期比值 {this.getValue(_.get(data, '9.rat', 0), 'percent')}</div>
                                </div>
                            </div>

                        </div>
                    </Row>

                    <div className="chart-content" style={{ background: "#fff" }}>
                        <div id="chart" style={{ height: 400 }}> </div>
                    </div>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-1TotalPayrollCostAnalysis/7-1-3/index.js